export const options: any[] = [
  { value: "0", label: "Pending" },
  { value: "1", label: "Interested" },
  { value: "2", label: "Not Interested" },
  { value: "3", label: "Follow Up" },
  { value: "4", label: "Voicemail" },
  { value: "5", label: "Invalid Number" },
  { value: "6", label: "Not In Service" },
  { value: "7", label: "DND" },
  { value: "8", label: "Citizens" },
];

export const options_issenior_0: any[] = [
  { value: "1", label: "Paid Data" },
  { value: "2", label: "Unpaid Data" },
  { value: "3", label: "Server Data" },
  { value: "4", label: "Senior Data" },
  { value: "5", label: "Junior Data" },
  { value: "6", label: "All Data" },
  { value: "7", label: "Referral Data" },
];
export const options_issenior_3: any[] = [
  { value: "1", label: "Paid Data" },
  { value: "2", label: "Unpaid Data" },
  { value: "3", label: "Server Data" },
  { value: "4", label: "Senior Data" },
  { value: "5", label: "Junior Data" },
  { value: "6", label: "All Data" },
  { value: "7", label: "Referral Data" },
];

export const followUpOptions: any[] = [
  { value: "1", label: "Interested" },
  { value: "2", label: "Not Interested" },
  { value: "3", label: "Follow Up" },
];

export const salesLinks: any[] = [
  { link: "/sales/report", label: "Sales Data", key: "sales" },
  { link: "/sales/followup-calls", label: "Follow Up Data", key: "followups" },
];

export const timeoptions = [
  { value: "1", label: "PST" },
  { value: "2", label: "MST" },
  { value: "3", label: "CST" },
  { value: "4", label: "EST" },
];

export const timeoptionsLables = [
  { value: "PST", label: "PST" },
  { value: "MST", label: "MST" },
  { value: "CST", label: "CST" },
  { value: "EST", label: "EST" },
];
